import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import ScoreChart from '../ScoreChart';
import { teamColors } from '../../../shared/chart-options';
import LineupBarChart from './LineupBarChart';
import LineupInfoModal from './LineupInfoModal';
import BoxScore from '../../shared/Boxscore';
import { getGameExplorerReport } from '../data/game-explorer-report';
import { useLineupInfoModal } from './useLineupInfoModal';

const FACTOR_OPTIONS = [
  { value: 'points', label: 'Points' },
  { value: 'efg', label: 'Effective FG%' },
  { value: 'tov', label: 'Turnover Rate' },
  { value: 'ftr', label: 'Free Throw Rate' },
  { value: 'orr', label: 'Offensive Rebound Rate' },
];

const Charts = ({ stats, pathTo, team }) => {
  const [factor, setFactor] = useState('points');
  const gameExplorerReport = useMemo(() => getGameExplorerReport(stats), [
    stats,
  ]);
  const modalDialog = useLineupInfoModal();
  const {
    homeShifts,
    visitorShifts,
    homeTeam,
    visitorTeam,
    game,
  } = gameExplorerReport;

  const handleHomeClick = shift => {
    const isCurrentTeam = homeTeam.id === team.id;
    modalDialog.openDialog(isCurrentTeam, shift, homeShifts);
  };
  const handleVisitorClick = shift => {
    const isCurrentTeam = visitorTeam.id === team.id;
    modalDialog.openDialog(isCurrentTeam, shift, visitorShifts);
  };

  useEffect(() => {
    if (factor) setFactor(factor);
    else setFactor(FACTOR_OPTIONS[0].value);
  }, [factor]);

  const handleFactorChange = event => {
    if (event) setFactor(event.target.value);
    else setFactor(FACTOR_OPTIONS[0].value);
  };

  return (
    <>
      <div className="s-game-explorer__data-container box box--has-border">
        <div className="s-game-explorer__header-container">
          <BoxScore game={game} />
          <div className="factor-select-container">
            <select
              value={factor}
              onChange={handleFactorChange}
              disabled={!gameExplorerReport}
            >
              {FACTOR_OPTIONS.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="s-game-explorer__chart-container">
          <div className="s-game-explorer__home">
            <LineupBarChart
              gameExplorerReport={gameExplorerReport}
              team={homeTeam}
              shifts={homeShifts}
              teamColor={teamColors.homeColor}
              onTeamShiftClicked={handleHomeClick}
            />
          </div>

          <ScoreChart gameExplorerReport={gameExplorerReport} factor={factor} />

          <div className="s-game-explorer__visitor">
            <LineupBarChart
              gameExplorerReport={gameExplorerReport}
              team={visitorTeam}
              shifts={visitorShifts}
              teamColor={teamColors.visitorColor}
              onTeamShiftClicked={handleVisitorClick}
            />
          </div>
        </div>
      </div>

      <LineupInfoModal pathTo={pathTo} {...modalDialog} />
    </>
  );
};

Charts.propTypes = {
  stats: PropTypes.object.isRequired,
};

export default Charts;
